import { render, staticRenderFns } from "./ViewSalesInvoice.vue?vue&type=template&id=66b1932e"
import script from "./ViewSalesInvoice.vue?vue&type=script&lang=ts"
export * from "./ViewSalesInvoice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports